// eslint-disable-next-line import/no-cycle
import { utpAds as schemaUtpAds } from './schemas';
import UtpAdsDataStore from '@/data/datastores/UtpAdsDataStore';
import apiClient from './apiClient';

class UtpAdsDataStoreGraphQL implements UtpAdsDataStore {
  client: any = apiClient();

  async getUtpAdsData() {
    try {
      const response = await this.client.query({
        query: schemaUtpAds.getUtpAdsData
      });
      const data = response.data?.ads?.advertisement ?? {};
      return data;
    } catch (error) {
      throw new Error('error utp ads', { cause: error });
    }
  }
}

export default UtpAdsDataStoreGraphQL;
